import { InsuranceCompanyOffer } from './InsuranceCompanyOffer';

export const InsuranceCompany = (data) => {
  let firstOffer = null;

  const offers = (data?.zppCourseOffers || []).map((offer) => {
    const insuranceCompanyOffer = InsuranceCompanyOffer({ ...offer, cooperationKey: data.slug });
    if (!firstOffer) {
      firstOffer = insuranceCompanyOffer;
    }
    return insuranceCompanyOffer;
  });

  return {
    id: data.id || null,
    name: data.name || '',
    slug: data.slug || '',
    supportEmail: data.supportEmail || '',
    cooperationLogo: data.cooperationLogo || null,
    cooperationLogoHover: data.cooperationLogoHover || null,
    cooperationPartner: data.cooperationPartner || null,
    reductionRate: data.reductionRate || 0,
    content: {
      header: firstOffer?.content?.header || {}
    },
    offers
  };
};
